//Libary
import React, { Component } from 'react';
import Slider, { SliderTooltip, Handle } from 'rc-slider';
import ReactHighcharts from 'react-highcharts';
import { HashLink as Link } from 'react-router-hash-link';
//config
import config from '../../config';
ReactHighcharts.Highcharts.setOptions({ lang: { thousandsSep: ',' } })

class RetirementTrial extends Component {

    constructor(props) {
        super(props);
        this.state = {
            trialCalculationData: [],
            trialYear: config.trialSetting.trialYearDefalut,
            budget: config.trialSetting.budgetDefault,
            useYear: config.trialSetting.useYearDefault,
            altAmount: config.trialSetting.altAmountDefault,
            drspAmount: config.trialSetting.drspAmountDefault,
        }
    }

    trialCalculation() {
        let ATLvalue = document.getElementById("ATLvalue").value;
        let RSPvalue = document.getElementById("RSPvalue").value;
        let ExpectationReward = document.getElementById("ExpectationReward").value;

        let Data = [];
        let Parameter = Math.pow((1.0 + (parseFloat(ExpectationReward) / 100.0)), (1.0 / 12.0)) - 1;
        /*Row1 是特例*/
        let RewardPart = 100 * (Parameter + 1);
        let Accumulation = (parseInt(ATLvalue) + parseInt(RSPvalue)) / RewardPart;
        let NowMktAmt = Accumulation * RewardPart;

        let RowCompute = (MktAmt, Persontage, SumAccumulation, CRound, MaxRound) => {
            if (MaxRound > CRound) {
                let RewardPart = Persontage * (Parameter + 1);
                let Accumulation = RSPvalue / RewardPart;
                SumAccumulation += Accumulation;
                let NowMktAmt = SumAccumulation * RewardPart;
                NowMktAmt = RowCompute(NowMktAmt, RewardPart, SumAccumulation, CRound + 1, MaxRound);
                return NowMktAmt;
            } else {
                return MktAmt;
            }
        }

        /*'3年', '10年', '20年', '30年'*/
        Data.push(Math.round(RowCompute(NowMktAmt, RewardPart, Accumulation, 1, 36)));
        Data.push(Math.round(RowCompute(NowMktAmt, RewardPart, Accumulation, 1, 120)));
        Data.push(Math.round(RowCompute(NowMktAmt, RewardPart, Accumulation, 1, 240)));
        Data.push(Math.round(RowCompute(NowMktAmt, RewardPart, Accumulation, 1, 360)));
        this.setState({ trialCalculationData: Data })
    }

    handle(props) {
        const { value, dragging, index, ...restProps } = props;
        return (
            <SliderTooltip prefixCls="rc-slider-tooltip" overlay={`${value}`} visible={dragging} placement="top" key={index}>
                <Handle value={value} {...restProps} />
            </SliderTooltip>
        );
    };

    sliderChange(value, stateName) {
        this.setState({ [stateName]: value });
    }

    limit(inputObj, item) {
        let { maxName, minName, stateName } = item;
        if (inputObj.floatValue === undefined) {
            this.setState({ [stateName]: config.trialSetting[minName] });
            return inputObj;
        } else if (inputObj.floatValue <= config.trialSetting[maxName]) {
            this.setState({ [stateName]: inputObj.floatValue });
            return inputObj;
        }
    }

    /*  ========================公式說明========================
    請問您離退休還有多久?預計退休後每月花費金額?
    使用到變數為: 物價年增率i、 投資報酬率r、每月花費n、離退休時間d、可花多久t
    客戶會回答n跟d，i假設為1.5%、t假設45年、r假設為3.5%

    計算過程，會用兩個迴圈，
    第一個迴圈初始值設300萬，間隔100萬，終止值5億，第二個迴圈為1年至t年，間隔1年
    計算方式:   先從300萬開始， 第一年會變成300-(n*12)*(1+i)^d
               第二年會變成 (300-(n*12)*(1+i)^d)*(1+r)-(n*12)*(1+i)^(d+1)
               第三年會變成[(300-(n*12)*(1+i)^d)*(1+r)-(n*12)*(1+i)^(d+1)]*(1+r)- (n*12)*(1+i)^(d+2)
               依此類推
               假設到第t年時，計算數值仍大於0，那答案就是300萬
               如果不是，就再從400萬開始重跑一次上述流程

    請問願意單筆投入多少錢?每月投入多少錢至退休計畫?
    使用到的變數為: 單筆投入金額b、定期定額金額a、投資時間d(與上一題同樣)
    計算方式只會使用到一個迴圈，初始值為2%、間隔為0.1%、終止值為20%
    計算方式: 先從2%開始，退休金會是      (a*12)*(1-(1+2%)^d)/(1-(1+2%))+b*(1+2%)^d
                      如果此數值大於會等於第一題的答案，則答案就是2%
                      2.1%時，退休金會是(a*12)*(1-(1+2.1%)^d)/(1-(1+2.1%))+b*(1+2%)^d
                      如果不是就跑2.1%，一路跑下去到有答案或是20%為止
    */

    trialGetValue(evt) {
        let i = 0.015,                //物價年增率
            t = this.state.useYear,   //退休後要用多久
            r = 0.035,                //投資報酬率
            d = this.state.trialYear, //離退休時間
            n = this.state.budget,    //每月花費
            b = this.state.altAmount, //單筆投入金額
            a = this.state.drspAmount,//定期定額金額
            q1Answer = 3000000,       //第一題 答案初始值 
            q1Flag = true,            //第一題 插旗
            q2Answer = 0.02,          //第二題 答案初始值
            q2Flag = true;            //第二題 插旗
        while (q1Flag) {
            if (this.trialQ1Answer(q1Answer, n, i, d, r, t) === false && q1Answer <= 500000000) {
                q1Answer = q1Answer + 1000000;
            } else {
                q1Flag = false;
            }
        }
        while (q2Flag) {
            if (this.trialQ2Answer(q1Answer, q2Answer, a, b, d) === false && q2Answer <= 0.2) {
                q2Answer = Number((q2Answer + 0.001).toFixed(3));
            } else {
                q2Flag = false;
            }
        }
        this.props.setTrialAnswer(q2Answer);

        let top = document.getElementById("invest").offsetTop;
        window.scroll(0, top - 100);
    }

    trialQ1Answer(q1Answer, n, i, d, r, t) {
        let answerNum = q1Answer * (1 + r) - (12 * n) * ((1 + i) ** d) * (1 + i) ** 1;
        if (answerNum > 0) {
            for (let k = 1; k < t; k++) {
                answerNum = answerNum * (1 + r) - (12 * n) * (1 + i) ** d * (1 + i) ** (k + 1);
                if (answerNum < 0) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    trialQ2Answer(q1Answer, q2Answer, a, b, d) {
        let q2Num = (a * 12) * (1 - (1 + q2Answer) ** d) / (1 - (1 + q2Answer)) + b * (1 + q2Answer) ** d;
        if (q2Num > q1Answer) {
            return true;
        }
        return false;
    }


    render() {
        return <div>
            <section id="calculate">
                <div className="anueContainer">
                    <div className="titleBlock">
                        <h2 className="trialTitle" data-aos="flip-up" style={{color:"0f91d8"}}>
                            <i class="fa fa-paper-plane" aria-hidden="true"></i> 好規劃
                        </h2>
                    </div>
                    <div className="secText center" data-aos="fade-up">親子理財試算，要過好日子，就是這麼簡單！</div>
                </div>
                <div className="trialBlock">
                    <div className="trialInputBlockLeft">
                        <div>
                            <span>您預計用幾年達成理財目標？</span>
                            <span>{this.state.trialYear}年</span>
                            <Slider marks={{ [config.trialSetting.trialYearMin]: config.trialSetting.trialYearMin, [config.trialSetting.trialYearMax]: config.trialSetting.trialYearMax }} onChange={(val) => { this.sliderChange(val, "trialYear") }} style={{ marginTop: "15px", marginLeft: "5px" }} min={config.trialSetting.trialYearMin} max={config.trialSetting.trialYearMax} value={this.state.trialYear} handle={this.handle} />
                        </div>
                        <div>
                            <span>期望未來每月孩子可用多少錢？</span>
                            <span>新台幣{config.format_with_substring(this.state.budget)}</span>
                            <Slider marks={{ [config.trialSetting.budgetMin]: config.format_with_substring(config.trialSetting.budgetMin), [config.trialSetting.budgetMax]: config.format_with_substring(config.trialSetting.budgetMax) }} onChange={(val) => { this.sliderChange(val, "budget") }} style={{ marginTop: "15px", marginLeft: "5px" }} min={config.trialSetting.budgetMin} max={config.trialSetting.budgetMax} step={config.trialSetting.budgetStep} value={this.state.budget} handle={this.handle} />
                        </div>
                        <div>
                            <span>期望這筆錢可讓孩子用多久？</span>
                            <span>{this.state.useYear}年</span>
                            <Slider marks={{ [config.trialSetting.useYearMin]: config.trialSetting.useYearMin, [config.trialSetting.useYearMax]: config.trialSetting.useYearMax }} onChange={(val) => { this.sliderChange(val, "useYear") }} style={{ marginTop: "15px", marginLeft: "5px" }} min={config.trialSetting.useYearMin} max={config.trialSetting.useYearMax} value={this.state.useYear} handle={this.handle} />
                        </div>
                    </div>
                    <div className="trialInputBlockRight">
                        <div>
                            <span>單筆可投資金額?</span>
                            <span>新台幣{config.format_with_substring(this.state.altAmount)}</span>
                            <Slider marks={{ [config.trialSetting.altAmountMin]: config.format_with_substring(config.trialSetting.altAmountMin), [config.trialSetting.altAmountMax]: config.format_with_substring(config.trialSetting.altAmountMax) }} onChange={(val) => { this.sliderChange(val, "altAmount") }} style={{ marginTop: "15px", marginLeft: "5px" }} min={config.trialSetting.altAmountMin} max={config.trialSetting.altAmountMax} value={this.state.altAmount} handle={this.handle} step={config.trialSetting.altAmountStep} />
                        </div>
                        <div>
                            <span>定期定額可投資金額?</span>
                            <span>新台幣{config.format_with_substring(this.state.drspAmount)}</span>
                            <Slider marks={{ [config.trialSetting.drspAmountMin]: config.format_with_substring(config.trialSetting.drspAmountMin), [config.trialSetting.drspAmountMax]: config.format_with_substring(config.trialSetting.drspAmountMax) }} onChange={(val) => { this.sliderChange(val, "drspAmount") }} style={{ marginTop: "15px", marginLeft: "5px" }} min={config.trialSetting.drspAmountMin} max={config.trialSetting.drspAmountMax} value={this.state.drspAmount} handle={this.handle} step={config.trialSetting.drspAmountStep} />
                        </div>
                        <div>
                            <span>註：假設物價年增率1.5%，投資報酬率3.5%之親子理財試算結果</span>
                        </div>
                    </div>
                    <div>
                        <button onClick={evt => { this.trialGetValue(evt); }}>立即試算</button>
                        <Link to="/#invest">略過試算</Link>
                    </div>

                </div>
            </section>

        </div>
    }
}
export default RetirementTrial;